import { useMutation } from '@tanstack/react-query';
import { FormikErrors, FormikValues } from 'formik';
import { api } from '@/modules/common/api/index.ts';
import { queryClient } from '@/modules/common/query.ts';
import { withErrorHandling } from '@/modules/common/utils/error-utils.tsx';
import { ISSUER_REGISTER_ISSUERS_LIST_QUERY_KEY } from '@/modules/issuer-dashboard/queries/registers.tsx';
import { IssuerAddNewIssuerRequest } from 'api';

export const useIssuerAddNewIssuerMutation = ({
  setErrors,
  registerId,
}: {
  setErrors?: (errors: FormikErrors<FormikValues>) => void;
  registerId: number;
}) => {
  return useMutation({
    mutationFn: async (payload: IssuerAddNewIssuerRequest) => {
      const response = await withErrorHandling(
        api.v1.issuerAddV1UsersIssuerAddPost({
          ...payload,
          redirect_url: import.meta.env.VITE_SR_URL,
        }),
        {
          loading: 'Adding new issuer...',
          success: 'Issuer added',
          setErrors,
        },
      );

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([ISSUER_REGISTER_ISSUERS_LIST_QUERY_KEY, registerId]);
    },
  });
};

export const useIssuerDeleteIssuerMutation = (registerId: number) => {
  return useMutation({
    mutationFn: async (id: number) => {
      const response = await withErrorHandling(
        api.v1.issuerDeleteUserRegistersV1SrIssuerUserRegistersIdDelete({ id }),
        {
          loading: 'Deleting issuer...',
          success: 'Issuer deleted',
        },
      );

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([ISSUER_REGISTER_ISSUERS_LIST_QUERY_KEY, registerId]);
    },
  });
};
